module.exports = __webpack_public_path__ + "img/b2b02.8662cbc2.png";